export const VIEW_RIDE = 'RIDE/VIEW_RIDE';

export interface RideDispatchTypes {
  type: string;
  payload?: any;
}